import api from './api';

export const getDashboard = () => api.get('/reports/dashboard');
export const getDailyReport = (date) => api.get('/reports/daily', { params: { date } });
export const getWeeklyReport = (params) => api.get('/reports/weekly', { params });
export const getMonthlyReport = (params) => api.get('/reports/monthly', { params });
export const getYearlyReport = (params) => api.get('/reports/yearly', { params });
export const getPaymentAnalytics = (params) => api.get('/reports/analytics/payments', { params });
export const getStockAnalytics = (params) => api.get('/reports/analytics/stock', { params });
export const getCustomerAnalytics = (params) => api.get('/reports/analytics/customers', { params });
export const getProfitAnalytics = (params) => api.get('/reports/analytics/profit', { params });
export const getTopProducts = (params) => api.get('/reports/top-products', { params });
export const getTopCustomers = (params) => api.get('/reports/top-customers', { params });
export const getStaffPerformance = (params) => api.get('/reports/staff-performance', { params });
export const generateCustomReport = (params) => api.post('/reports/custom', params);
